class UnauthorizedError extends Error {
    constructor(cause?: Error) {
        super("No está autenticado para acceder a este recurso", {
            cause,
        });
    }
}

export { UnauthorizedError };
